// extracted by mini-css-extract-plugin
export default {"FontFileForm":"FontFileForm_FontFileForm__GpYAS"};